import Vue from 'vue';

const success = (response, context) => {
    context.closeModal('#own-rental-modal');
    context.ownRentalUrl = response.ownRental;

    context.get_rental_market_data (context.selectedRental);
    toastr.success(response.msg);
    context.disabled = false;
    context.smallLoading = false;
    return response.data;
};

const failed = (error, context) => {
    context.disabled = false;
    context.smallLoading = false;
    context.showToasterError(error);
};

export default (id, url, context) => Vue.$http.post(`/rentals/add-or-update-own-url/${id}`, { ownRentalUrl: url })
    .then((response) => {
      if (response && response.status === 200) {
        success(response.data, context);
      }
    }).catch((error) => {
      failed(error, context);
    });



// WEBPACK FOOTER //
// ./src/app/services/rental/addOrUpdateOwnUrl.js